// extracted by mini-css-extract-plugin
export default {"title":"title--yCPSx","slider_value":"slider_value--TBLVd","slider":"slider--dlep9"};